module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "value": _vm.formattedText(),
      "required": _vm.required,
      "rules": _vm.rulesMerged,
      "error-messages": _vm.errorsMerged,
      "readonly": _vm.readonly,
      "hint": _vm.hint
    },
    on: {
      "input": _vm.updateText
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0304b36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NumberField.vue
// module id = 937
// module chunks = 1